module.exports = __webpack_public_path__ + "static/media/super.3bbb8484.png";